import { useState, useCallback } from "react";
import axios from "axios";
import { api_v3_list_of_players_by_playerIds } from "../utils/constants";

export const usePlayerData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [playerData, setPlayerData] = useState(null);

  const fetchPlayer = useCallback(async (id) => {
    setLoading(true);
    try {
      const response = await axios.get(api_v3_list_of_players_by_playerIds(id));
      if (response.status === 200 && response.data.length > 0) {
        setPlayerData(response.data[0]);
        setError(false);
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, playerData, fetchPlayer, setPlayerData };
};
